import { Link } from '@material-ui/core';
import React from 'react';

import { DateTimeRangeComponent } from '~/src/dash/components/datepicker/date-time-range-component';
import { Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IProps } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';
import { SingleSelect } from '~/src/dash/views/singleselect-view';

export const QueryRow = (props: IProps) => {
  if (props.reportType === undefined) {
    return null;
  }

  return (
    <Rows responsive verticalPadding>
      <Row noPadding>
        <Cols wrap style={{ alignItems: 'center' }}>
          <Col style={{ minWidth: '85px' }}>
            <Text small bold>
              {' '}
              Report Type{' '}
            </Text>
          </Col>
          <Col hugeHorizontalPadding>
            <SingleSelect
              name='Report Type'
              label=''
              items={props.reportTypesList}
              value={props.reportType.title}
              onChange={props.handleChangeReportType}
              style={{
                width: '360px',
                border: `1px solid ${publicaColors.lightGray}`,
                borderRadius: '5px',
                fontSize: '14px',
                marginTop: '4px',
                marginBottom: '2px',
                minWidth: '120px',
                paddingLeft: '2px',
              }}
            />
          </Col>
          <Col
            extraSmallPadding
            style={{
              width: 'fit-content',
              background: `${publicaColors.veryLightGray}`,
              borderRadius: '5px',
            }}
          >
            <Cols style={{ alignItems: 'center' }}>
              <Col smallHorizontalPadding paddingTop='5px'>
                <img src='/assets/shared/svg/GuideIcon.svg' />
              </Col>
              <Col>
                <Text small>For more details, read our report type guide.</Text>
              </Col>
              <Col horizontalPadding>
                {/* TODO: add a url to the link */}
                <Link>
                  <Text
                    small
                    style={{
                      color: `${publicaColors.lightBlue}`,
                    }}
                  >
                    {' '}
                    Learn More{' '}
                  </Text>
                </Link>
              </Col>
            </Cols>
          </Col>
        </Cols>
      </Row>
      <Row noHorizontalPadding>
        <Cols style={{ alignItems: 'flex-start' }}>
          <Col marginTop='8px' style={{ minWidth: '85px' }}>
            <Text small bold>
              {' '}
              Date Range{' '}
            </Text>
          </Col>
          <Col
            style={{
              fontSize: '12px',
              paddingLeft: spacing.huge,
            }}
          >
            <Rows>
              <Row noPadding>
                <SingleSelect
                  name='Date Range'
                  label=''
                  items={props.dateRangeList}
                  value={props.dateRange.apiKey}
                  onChange={props.handleChangeDateRange}
                  style={{
                    width: '360px',
                    border: `1px solid ${publicaColors.lightGray}`,
                    borderRadius: '5px',
                    fontSize: '14px',
                    marginTop: '4px',
                    marginBottom: '2px',
                    minWidth: '120px',
                    paddingLeft: '2px',
                  }}
                  disableAlphanumSort
                />
              </Row>
              {props.dateRange.apiKey === 'CUSTOM' && (
                <Row noHorizontalPadding paddingBottom='0px'>
                  <DateTimeRangeComponent
                    enableClearSelection={true}
                    timezone={'America/New_York'}
                    start={props.startDate}
                    end={props.endDate}
                    maxDateExtended={-2}
                    onChange={props.handleDateChange}
                    disableTime={true}
                  />
                </Row>
              )}
            </Rows>
          </Col>
        </Cols>
      </Row>
    </Rows>
  );
};
